"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PARAM_KEY = exports.ADDON_ID = void 0;
var ADDON_ID = 'storybook/outline';
exports.ADDON_ID = ADDON_ID;
var PARAM_KEY = 'outline';
exports.PARAM_KEY = PARAM_KEY;